import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box, Grid, Card, CardContent, Typography, TextField, Button, Switch, FormControlLabel, MenuItem, Avatar } from '@mui/material';
import axios from 'axios';

export default function CreateWorker({ companyid, onSuccess, onCancel }) {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [position, setPosition] = useState('');
  const [email, setEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [employmentType, setEmploymentType] = useState('');
  const [isActive, setIsActive] = useState(true);
  const [department, setDepartment] = useState('');
  const [notes, setNotes] = useState('');
  const navigate = useNavigate();

  const SERVER_URL = process.env.REACT_APP_BACKEND_SERVER_URL;

  const postData = async () => {
    try {
      await axios.post(`${SERVER_URL}/api/workers`, {
        companyid,
        firstName,
        lastName,
        position,
        email,
        phoneNumber,
        employmentType,
        isActive,
        department,
        notes
      });
      if (onSuccess) onSuccess();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div style={{ backgroundColor: '#001536', width: '100%', padding: '20px' }}>
      <Grid container justifyContent="center">
        <Card sx={{ maxWidth: 600, width: '100%', backgroundColor: '#00122E', color: '#ffffff', borderRadius: 2, boxShadow: 3 }}>
          <CardContent>
            <Typography variant="h6" sx={{ color: '#ffffff', mb: 2, textAlign: 'center' }}>
              Novi radnik
            </Typography>
            <TextField
              label="Ime"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              fullWidth
              margin="normal"
              variant="outlined"
              InputLabelProps={{ style: { color: '#ffffff' } }}
              InputProps={{ style: { color: '#ffffff' } }}
            />
            <TextField
              label="Prezime"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              fullWidth
              margin="normal"
              variant="outlined"
              InputLabelProps={{ style: { color: '#ffffff' } }}
              InputProps={{ style: { color: '#ffffff' } }}
            />
            <TextField
              label="Pozicija"
              value={position}
              onChange={(e) => setPosition(e.target.value)}
              fullWidth
              margin="normal"
              variant="outlined"
              InputLabelProps={{ style: { color: '#ffffff' } }}
              InputProps={{ style: { color: '#ffffff' } }}
            />
            <TextField
              label="Email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              fullWidth
              margin="normal"
              variant="outlined"
              InputLabelProps={{ style: { color: '#ffffff' } }}
              InputProps={{ style: { color: '#ffffff' } }}
            />
            <TextField
              label="Telefon"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              fullWidth
              margin="normal"
              variant="outlined"
              InputLabelProps={{ style: { color: '#ffffff' } }}
              InputProps={{ style: { color: '#ffffff' } }}
            />
            <TextField
              select
              label="Tip zaposlenja"
              value={employmentType}
              onChange={(e) => setEmploymentType(e.target.value)}
              fullWidth
              margin="normal"
              InputLabelProps={{ style: { color: '#ffffff' } }}
              SelectProps={{ style: { color: '#ffffff' } }}
            >
              <MenuItem value="puno radno vrijeme">Puno radno vrijeme</MenuItem>
              <MenuItem value="skraćeno radno vrijeme">Skraćeno radno vrijeme</MenuItem>
              <MenuItem value="honorarno">Honorarno</MenuItem>
            </TextField>
            <TextField
              label="Odjel"
              value={department}
              onChange={(e) => setDepartment(e.target.value)}
              fullWidth
              margin="normal"
              variant="outlined"
              InputLabelProps={{ style: { color: '#ffffff' } }}
              InputProps={{ style: { color: '#ffffff' } }}
            />
            <TextField
              label="Napomene"
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              fullWidth
              margin="normal"
              variant="outlined"
              multiline
              rows={3}
              InputLabelProps={{ style: { color: '#ffffff' } }}
              InputProps={{ style: { color: '#ffffff' } }}
            />
            <FormControlLabel
              control={<Switch checked={isActive} onChange={(e) => setIsActive(e.target.checked)} sx={{ color: '#fff' }} />}
              label={<Typography sx={{ color: '#fff' }}>Aktivan</Typography>}
            />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 3, mt: 3 }}>
              <Button variant="outlined"
                sx={{
                  backgroundColor: '#001B44',
                  color: '#fff',
                  border: '1px solid #3949ab',
                  '&:hover': { backgroundColor: '#001B44' },
                }}
                onClick={() => onCancel && onCancel()}>
                Odustani
              </Button>
              <Button
                variant="outlined"
                sx={{
                  backgroundColor: '#001B44',
                  color: '#fff',
                  border: '1px solid #3949ab',
                  '&:hover': { backgroundColor: '#001B44' },
                }}
                onClick={postData}
              >
                Spasi
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Grid>
    </div>
  );
}
